export default __webpack_public_path__ + "stumbler-seventh.7a0ba9e1.mp4";